import { alertActions } from '../../store/actions'
import { regConstants } from '../../store/constants'
import axios from 'axios'

export const valid = {
  checkFindInput,
  checkbizNo,
  checkbizNo2,  //자리수만 체크
  checkbizNo3,
  isValidJuminNo,
}

/***************
  입력정보 체크
***************/

function checkFindInput(params) {
  return (dispatch) => {
    if (params.hasOwnProperty('id')) {
      if (!params.id || params.id?.length < 4) {
        dispatch(
          alertActions.error({
            title: '아이디는',
            message: '아이디는는 최소 4자리부터 최대 40자리입니다.',
          }),
        )
        return false
      }
    }

    if (params.hasOwnProperty('name')) {
      if (!params.name || params.name?.length <= 0) {
        dispatch(
          alertActions.error({
            title: '이름',
            message: '이름이 입력되지 않았습니다.',
          }),
        )
        return false
      }
    }

    if (params.hasOwnProperty('email')) {
      if (!params.email || params.email?.length <= 0) {
        dispatch(
          alertActions.error({
            title: '이메일',
            message: '이메일이 입력되지 않았습니다.',
          }),
        )
        return false
      } else if (!regConstants.email.test(params.email)) {
        dispatch(
          alertActions.error({
            title: '이메일',
            message: '유효한 이메일 주소가 아닙니다.',
          }),
        )
        return false
      }
    }

    if (params.hasOwnProperty('phone')) {
      if (!params.phone || params.phone?.length <= 0) {
        dispatch(
          alertActions.error({
            title: '휴대폰번호',
            message: '휴대폰번호가 입력되지 않았습니다.',
          }),
        )
        return false
      } else if (!regConstants.mobile.test(params.phone)) {
        dispatch(
          alertActions.error({
            title: '휴대폰번호',
            message: '유효한 휴대폰번호가 아닙니다.\n숫자만 입력해주세요.',
          }),
        )
        return false
      }
    }

    if (params.hasOwnProperty('mobileNo')) {
      if (!params.mobileNo || params.mobileNo?.length <= 0) {
        dispatch(
          alertActions.error({
            title: '휴대폰',
            message: '휴대폰번호가 입력되지 않았습니다.',
          }),
        )
        return false
      } else if (!regConstants.mobile.test(params.mobileNo)) {
        dispatch(
          alertActions.error({
            title: '휴대폰번호',
            message: '유효한 휴대폰번호가 아닙니다.\n숫자만 입력해주세요.',
          }),
        )
        return false
      }
    }

    if (params.hasOwnProperty('isWtdrYn')) {
      if (!params.isWtdrYn) {
        dispatch(
          alertActions.error({
            title: '회원탈퇴 약관동의',
            message: '회원탈퇴 약관동의에 동의하셔야 합니다.',
          }),
        )
        return false
      }
    }

    // 2021.03.10 임시추가
    if (params.hasOwnProperty('passwd')) {
      if (!params.passwd || params.passwd?.length <= 0) {
        dispatch(
          alertActions.error({
            title: '비밀번호',
            message: '비밀번호를 입력해주세요.',
          }),
        )
        return false
      }
    }

    // 2022-07-06 추가
    if (params.hasOwnProperty('pass')) {
      if (!params.pass || params.pass?.length <= 0) {
        dispatch(
          alertActions.error({
            title: '현재 비밀번호',
            message: '현재 비밀번호를 입력해주세요.',
          }),
        )
        return false
      }
    }

    if (params.hasOwnProperty('tmpNewPwd')) {
      if (!params.tmpNewPwd || params.tmpNewPwd?.length <= 0) {
        dispatch(
          alertActions.error({
            title: '새 비밀번호',
            message: '새 비밀번호를 입력해주세요.',
          }),
        )
        return false
      }
    }

    if (params.hasOwnProperty('errMessage')) {
      if (params.errMessage?.length > 0) {
        dispatch(
          alertActions.error({
            title: '유효하지 않은 비밀번호',
            message: params.errMessage,
          }),
        )
        return false
      }
    }
    //임시 제목
    if (params.hasOwnProperty('title')) {
      if (!params.title || params.title?.length <= 0) {
        dispatch(
          alertActions.error({
            title: '제목',
            message: '제목을 입력해주세요.',
          }),
        )
        return false
      }
    }
    //임시 내용
    if (params.hasOwnProperty('text')) {
      if (!params.text || params.text?.length <= 0) {
        dispatch(
          alertActions.errer({
            title: '내용',
            message: '내용을 입력해주세요.',
          }),
        )
        return false
      }
    }

    return true
  }
}

function checkbizNo(bizNo) {
  let flag = false
  // 넘어온 값의 정수만 추츨하여 문자열의 배열로 만들고 10자리 숫자인지 확인합니다.
  // 정수만 추출
  bizNo = bizNo != null && bizNo.length > 0 ? bizNo.replace(/[^0-9]/gi, '') : ''
  // 사업자번호 길이 체크
  if (bizNo.length !== 10) {
    return false
  }

  if (!flag) {
    // 합 / 체크키
    let sum = 0,
      key = [1, 3, 7, 1, 3, 7, 1, 3, 5]

    for (let i = 0; i < 9; i++) {
      sum += key[i] * Number(bizNo[i])
    }

    flag = 10 - ((sum + Math.floor((key[8] * Number(bizNo[8])) / 10)) % 10) === Number(bizNo[9])
  }

  return flag
}

// 자리수만 체크
function checkbizNo2(bizNo) {
  let flag = false
  // 넘어온 값의 정수만 추츨하여 문자열의 배열로 만들고 10자리 숫자인지 확인합니다.
  // 정수만 추출
  bizNo = bizNo != null && bizNo.length > 0 ? bizNo.replace(/[^0-9]/gi, '') : ''
  // 사업자번호 길이 체크
  if (bizNo.length !== 10) {
    flag = false
  } else {
    flag = true
  }
  return flag
}

async function checkbizNo3(bizNo) {
  let flag = false
  const params = {b_no: [bizNo]}

  let url = 'https://api.odcloud.kr/api/nts-businessman/v1/status?serviceKey=' + process.env.REACT_APP_BUSINESS_API_KEY;
  await axios
      .post(url, params)
      .then((res) => {
        if (res.data.data[0].b_stt_cd === '01') {
          console.log("valid" + res)
          flag = true
        } else {
          console.log("invalid" + res)
          flag = false
        }
      })
      .catch((res) => {
        flag = false
      })
  return flag;
}


// 주민등록번호의 유효성을 체크
function isValidJuminNo(regNo1, regNo2) {
  var tmpFrm = document.frm_OnlineEdu
  var jumin1 = regNo1
  var jumin2 = regNo2
  var yy = jumin1.substr(0, 2) // 년도
  var mm = jumin1.substr(2, 2) // 월
  var dd = jumin1.substr(4, 2) // 일
  var genda = jumin2.substr(0, 1) // 성별
  var msg, ss, cc
  // 숫자가 아닌 것을 입력한 경우
  if (!isNumeric(jumin1)) {
    //alert("주민등록번호 앞자리를 숫자로 입력하세요.");
    //tmpFrm.txt_Jumin_1.focus();
    return false
  }

  // 길이가 6이 아닌 경우
  if (jumin1.length != 6) {
    //alert("주민등록번호 앞자리를 다시 입력하세요.");
    //tmpFrm.txt_Jumin_1.focus();
    return false
  }

  // 첫번째 자료에서 연월일(YYMMDD) 형식 중 기본 구성 검사
  if (yy < '00' || yy > '99' || mm < '01' || mm > '12' || dd < '01' || dd > '31') {
    //alert("주민등록번호 앞자리를 다시 입력하세요.");
    //tmpFrm.txt_Jumin_1.focus();
    return false
  }

  // 숫자가 아닌 것을 입력한 경우
  if (!isNumeric(jumin2)) {
    //alert("주민등록번호 뒷자리를 숫자로 입력하세요.");
    //tmpFrm.txt_Jumin_2.focus();
    return false
  }
  // 길이가 7이 아닌 경우
  if (jumin2.length != 7) {
    //alert("주민등록번호 뒷자리를 다시 입력하세요.");
    //tmpFrm.txt_Jumin_2.focus();
    return false
  }

  // 성별부분이 1 ~ 4 가 아닌 경우
  if (genda < '1' || genda > '4') {
    //alert("주민등록번호 뒷자리를 다시 입력하세요.");
    //tmpFrm.txt_Jumin_2.focus();
    return false
  }

  // 연도 계산 - 1 또는 2: 1900년대, 3 또는 4: 2000년대
  cc = genda == '1' || genda == '2' ? '19' : '20'
  // 첫번째 자료에서 연월일(YYMMDD) 형식 중 날짜 형식 검사
  if (isValidDate(cc + yy + mm + dd) == false) {
    //alert("주민등록번호 앞자리를 다시1 입력하세요.");
    //tmpFrm.txt_Jumin_1.focus();
    return false
  }

  // Check Digit 검사
  if (!isSSN(jumin1, jumin2)) {
    //alert("입력한 주민등록번호를 검토한 후, 다시 입력하세요.");
    //tmpFrm.txt_Jumin_1.focus();
    return false
  }
  return true
}
function isValidDate(iDate) {
  if (iDate.length != 8) {
    return false
  }

  var oDate = new Date()
  oDate.setFullYear(iDate.substring(0, 4))
  oDate.setMonth(Number(iDate.substring(4, 6)) - 1)
  oDate.setDate(iDate.substring(6))
  if (
    Number(oDate.getFullYear()) != Number(iDate.substring(0, 4)) ||
    Number(oDate.getMonth() + 1) != Number(iDate.substring(4, 6)) ||
    Number(oDate.getDate()) != Number(iDate.substring(6))
  ) {
    return false
  }

  return true
}

function isNumeric(s) {
  for (var i = 0; i < s.length; i++) {
    var c = s.substr(i, 1)
    if (c < '0' || c > '9') return false
  }
  return true
}

function isSSN(s1, s2) {
  var n = 2
  var sum = 0
  for (var i = 0; i < s1.length; i++) sum += Number(s1.substr(i, 1)) * n++
  for (var i = 0; i < s2.length - 1; i++) {
    sum += Number(s2.substr(i, 1)) * n++
    if (n == 10) n = 2
  }

  var c = 11 - (sum % 11)
  if (c == 11) c = 1
  if (c == 10) c = 0
  if (c != Number(s2.substr(6, 1))) return false
  else return true
}
